import { Settings } from "lucide-react";
import React, { useEffect, useState } from "react";
import { SettingsModal } from "./SettingsModal";

export const FilterButton = ({
	showDrafts,
	showBotPRs,
	onToggleDrafts,
	onToggleBotPRs,
	sortOption,
	onSetSortOption,
	showPendingWithProjectRules,
	onTogglePendingWithProjectRules,
	showPendingWithAllApprovals,
	onTogglePendingWithAllApprovals,
	greyOutBlockingComments,
	onToggleGreyOutBlockingComments,
	enableCommentsExpansion,
	onToggleCommentsExpansion,
	preloadResponses,
	onTogglePreloadResponses,
	quickFilterStyle,
	onSetQuickFilterStyle,
	viewMode,
	onSetViewMode,
	showSwimlaneMergedColumn,
	onToggleShowSwimlaneMergedColumn,
	showSwimlaneDeletedColumn,
	onToggleShowSwimlaneDeletedColumn,
	swimlaneWorkstreamsEnabled,
	onToggleSwimlaneWorkstreams,
	useLocalTime,
	onToggleUseLocalTime,
	watchProjects,
	setWatchProjects,
	excludeProjects,
	setExcludeProjects,
	swimlaneHideCreatedDaysThreshold,
	setSwimlaneHideCreatedDaysThreshold,
	swimlaneHideUpdatedDaysThreshold,
	setSwimlaneHideUpdatedDaysThreshold,
}) => {
	const [settingsModalOpen, setSettingsModalOpen] = useState(false);

	// Handle Escape key to close modal
	useEffect(() => {
		const handleEscapeKey = (e) => {
			if (e.key === "Escape" && settingsModalOpen) {
				setSettingsModalOpen(false);
			}
		};

		document.addEventListener("keydown", handleEscapeKey);
		return () => document.removeEventListener("keydown", handleEscapeKey);
	}, [settingsModalOpen]);

	return (
		<>
			<button
				type="button"
				onClick={() => setSettingsModalOpen(true)}
				className="group flex h-8 w-8 items-center justify-center rounded-md text-[var(--surface-elevated-muted)] hover:bg-[var(--surface-elevated-hover)] hover:text-[var(--color-text-primary)] focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] focus:ring-opacity-50 active:scale-[0.96] transition-[background-color,color,transform]"
				aria-label="Open settings"
			>
				<Settings
					className="w-3.5 h-3.5 transition-transform duration-500 ease-out motion-safe:group-hover:rotate-90"
					strokeWidth={2}
				/>
			</button>

			{settingsModalOpen && (
				<SettingsModal
					isOpen={settingsModalOpen}
					onClose={() => setSettingsModalOpen(false)}
					showDrafts={showDrafts}
					showBotPRs={showBotPRs}
					onToggleDrafts={onToggleDrafts}
					onToggleBotPRs={onToggleBotPRs}
					sortOption={sortOption}
					onSetSortOption={onSetSortOption}
					showPendingWithProjectRules={showPendingWithProjectRules}
					onTogglePendingWithProjectRules={onTogglePendingWithProjectRules}
					showPendingWithAllApprovals={showPendingWithAllApprovals}
					onTogglePendingWithAllApprovals={onTogglePendingWithAllApprovals}
					greyOutBlockingComments={greyOutBlockingComments}
					onToggleGreyOutBlockingComments={onToggleGreyOutBlockingComments}
					enableCommentsExpansion={enableCommentsExpansion}
					onToggleCommentsExpansion={onToggleCommentsExpansion}
					preloadResponses={preloadResponses}
					onTogglePreloadResponses={onTogglePreloadResponses}
					quickFilterStyle={quickFilterStyle}
					onSetQuickFilterStyle={onSetQuickFilterStyle}
					viewMode={viewMode}
					onSetViewMode={onSetViewMode}
					showSwimlaneMergedColumn={showSwimlaneMergedColumn}
					onToggleShowSwimlaneMergedColumn={onToggleShowSwimlaneMergedColumn}
					showSwimlaneDeletedColumn={showSwimlaneDeletedColumn}
					onToggleShowSwimlaneDeletedColumn={onToggleShowSwimlaneDeletedColumn}
					swimlaneWorkstreamsEnabled={swimlaneWorkstreamsEnabled}
					onToggleSwimlaneWorkstreams={onToggleSwimlaneWorkstreams}
					useLocalTime={useLocalTime}
					onToggleUseLocalTime={onToggleUseLocalTime}
					watchProjects={watchProjects}
					setWatchProjects={setWatchProjects}
					excludeProjects={excludeProjects}
					setExcludeProjects={setExcludeProjects}
					swimlaneHideCreatedDaysThreshold={swimlaneHideCreatedDaysThreshold}
					setSwimlaneHideCreatedDaysThreshold={
						setSwimlaneHideCreatedDaysThreshold
					}
					swimlaneHideUpdatedDaysThreshold={swimlaneHideUpdatedDaysThreshold}
					setSwimlaneHideUpdatedDaysThreshold={
						setSwimlaneHideUpdatedDaysThreshold
					}
				/>
			)}
		</>
	);
};
